import { apiSendJson } from "@/api/apicommon"

export default {
    async deleteRelative(relationshipId: string) {
        const method = "POST"
        const endpoint = "/relationship/deleteRelative/"
        const json = {
            "relationshipId": relationshipId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updatePatientPersonDescription(relationshipId: string, description: string) {
        const method = "POST"
        const endpoint = "/relationship/updatePatientPersonDescription/"
        const json = {
            "relationshipId": relationshipId,
            "description": description
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updatePatientPersonNote(relationshipId: string, note: string) {
        const method = "POST"
        const endpoint = "/relationship/updatePatientPersonNote/"
        const json = {
            "relationshipId": relationshipId,
            "note": note
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addLuCnsPatientToInstitute(lastName:string, firstName:string, genderType: string, cnsNumber:string) {
        const method = "POST"
        const endpoint = "/relationship/addLuCnsPatientToInstitute/"
        const json = {
            "lastName": lastName,
            "firstName": firstName,
            "genderType": genderType,
            "cnsNumber": cnsNumber,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateLuCnsSuffix(relationshipUuid: string, cnsSuffix: string, instituteUuid: string, patientUuid: string) {
        const method = "POST"
        const endpoint = "/relationship/updateLuCnsSuffix/"
        const json = {
            "relationshipUuid": relationshipUuid,
            "cnsSuffix": cnsSuffix,
            "instituteUuid": instituteUuid,
            "patientUuid":patientUuid
        }
        return await apiSendJson(method, endpoint, json)
    },    
    async updateLuCnsAffiliationNumber(relationshipUuid: string, cnsAffiliationNumber: string, instituteUuid: string) {
        const method = "POST"
        const endpoint = "/relationship/updateLuCnsAffiliationNumber/"
        const json = {
            "relationshipUuid": relationshipUuid,
            "cnsAffiliationNumber": cnsAffiliationNumber,
            "instituteUuid": instituteUuid,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateLuCnsAccidentDescription(cnsWorkAccidentId:string, accidentDescription:string) {
        const method = "POST"
        const endpoint = "/relationship/updateLuCnsAccidentDescription/"
        const json = {
            "cnsWorkAccidentId": cnsWorkAccidentId,
            "accidentDescription": accidentDescription,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateLuCnsAccidentNumber(cnsWorkAccidentId:string, accidentNumber:string) {
        const method = "POST"
        const endpoint = "/relationship/updateLuCnsAccidentNumber/"
        const json = {
            "cnsWorkAccidentId": cnsWorkAccidentId,
            "accidentNumber": accidentNumber,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateLuCnsAccidentDate(cnsWorkAccidentId:string, accidentDate:string) {
        const method = "POST"
        const endpoint = "/relationship/updateLuCnsAccidentDate/"
        const json = {
            "cnsWorkAccidentId": cnsWorkAccidentId,
            "accidentDate": accidentDate,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addLuCnsWorkAccidentToInsurance(relationshipId:string, accidentDate:string, accidentNumber:string, accidentDescription:string) {
        const method = "POST"
        const endpoint = "/relationship/addLuCnsWorkAccidentToInsurance/"
        const json = {
            "relationshipId": relationshipId,
            "accidentDate": accidentDate,
            "accidentNumber": accidentNumber,
            "accidentDescription": accidentDescription,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addLuCnsReferenceDrToPwr(personWithRoleUuid:string, referenceDrMain:string, referenceDrReplacement:string, declarationNumber:string, declarationDate:string) {
        const method = "POST"
        const endpoint = "/relationship/addLuCnsReferenceDrToPwr/"
        const json = {
            "personWithRoleUuid": personWithRoleUuid,
            "referenceDrMain": referenceDrMain,
            "referenceDrReplacement": referenceDrReplacement,
            "declarationNumber": declarationNumber,
            "declarationDate": declarationDate,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async deleteLuCnsReferenceDr(relationshipUuid:string) {
        const method = "POST"
        const endpoint = "/relationship/deleteLuCnsReferenceDr/"
        const json = {
            "relationshipUuid": relationshipUuid,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateLuCnsReferenceDrMain(relationshipUuid:string, referenceDrMain:string) {
        const method = "POST"
        const endpoint = "/relationship/updateLuCnsReferenceDrMain/"
        const json = {
            "relationshipUuid": relationshipUuid,
            "referenceDrMain": referenceDrMain,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateLuCnsReferenceDrReplacement(relationshipUuid:string, referenceDrReplacement:string) {
        const method = "POST"
        const endpoint = "/relationship/updateLuCnsReferenceDrReplacement/"
        const json = {
            "relationshipUuid": relationshipUuid,
            "referenceDrReplacement": referenceDrReplacement,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateLuCnsReferenceDrDeclarationNumber(relationshipUuid:string, declarationNumber:string) {
        const method = "POST"
        const endpoint = "/relationship/updateLuCnsReferenceDrDeclarationNumber/"
        const json = {
            "relationshipUuid": relationshipUuid,
            "declarationNumber": declarationNumber,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateLuCnsReferenceDrDeclarationDate(relationshipUuid:string, declarationDate:string) {
        const method = "POST"
        const endpoint = "/relationship/updateLuCnsReferenceDrDeclarationDate/"
        const json = {
            "relationshipUuid": relationshipUuid,
            "declarationDate": declarationDate,
        }
        return await apiSendJson(method, endpoint, json)
    },      
    async deleteLuCnsWorkAccident(cnsWorkAccidentId:string) {
        const method = "POST"
        const endpoint = "/relationship/deleteLuCnsWorkAccident/"
        const json = {
            "cnsWorkAccidentId": cnsWorkAccidentId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateIsCnsActive(relationshipId: string, isCnsActive: boolean) {
        const method = "POST"
        const endpoint = "/relationship/updateIsCnsActive/"
        const json = {
            "relationshipId": relationshipId,
            "isCnsActive": isCnsActive,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateIsCmcmActive(relationshipId: string, isCmcmActive: boolean) {
        const method = "POST"
        const endpoint = "/relationship/updateIsCmcmActive/"
        const json = {
            "relationshipId": relationshipId,
            "isCmcmActive": isCmcmActive,
        }
        return await apiSendJson(method, endpoint, json)
    },
}
